module.exports = __webpack_public_path__ + "fonts/dee66e472223ecfb5198e10220142790.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/file_pdf_brown.svg
// module id = 2009
// module chunks = 0